import React, {useEffect} from 'react';
import Coin from '../../../SVG/Coin';
import Pencil from '../../../SVG/Pencil';
import CaseIcon from '../../../SVG/CaseIcon';
import {useLocation, useNavigate} from 'react-router-dom';
import SwitchIcon from '../../../SVG/SwitchIcon';
import ToggleOffIcon from '../../../SVG/ToggleOffIcon';
import {useTranslation} from '../../../hooks/useTranslation';

const CorporateAccountRow = ({
  item,
  data,
  type,
  setReactivateStatus,
  setCorporateData,
  setCurrentCorporateAccount,
  setTurnStatus,
  setPricingModal,
  setEditModal,
  setSettingsModal,
  setDeactivateStatus,
}) => {
  const {t} = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    return window.addEventListener('click', e => {
      if (
        e.target.closest('.corporate-action') === null &&
        e.target.closest('.corporate__dropdown') === null
      ) {
        setCorporateData(old => {
          let data = [...old];
          data?.map(item => {
            item.dropdown_status = false;
          });
          return data;
        });
      }
    });
  }, [location]);

  const changeDropdownStatus = () => {
    const newData = [...data];
    newData?.map(el => {
      if (el.id === item.id) {
        el.dropdown_status = !el.dropdown_status;
      } else {
        el.dropdown_status = false;
      }
    });
    setCorporateData(newData);
  };

  return (
    <div className='corporate__table-row'>
      <div className='corporate__table-th'>
        {item?.admin_first_name ? item?.admin_first_name : t('corporateAccount.status.noData')}
      </div>
      <div className='corporate__table-th'>
        {item?.admin_last_name ? item?.admin_last_name : t('corporateAccount.status.noData')}
      </div>
      <div className='corporate__table-th'>
        {item?.title ? item?.title : t('corporateAccount.status.noData')}
      </div>
      <div className='corporate__table-th'>
        {item?.admin_email ? item?.admin_email : t('corporateAccount.status.noData')}
      </div>
      <div className='corporate__table-th'>
        {item?.custom_inspections_enabled ? t('corporateAccount.status.on') : t('corporateAccount.status.off')}
      </div>
      <div className='corporate__table-th corporate-action'>
        <img
          src='/assets/icons/dots.svg'
          alt='dots'
          onClick={changeDropdownStatus}
        />
      </div>

      {item?.dropdown_status && (
        <div className='corporate__dropdown'>
          <div
            className='corporate__dropdown-elem'
            onClick={() => {
              setCurrentCorporateAccount(item);
              navigate(`/corporate/${item.id}`);
            }}
          >
            <CaseIcon color={'#999999'} />
            <p>{t('corporateAccount.actions.details')}</p>
          </div>
          <div
            className='corporate__dropdown-elem'
            onClick={() => {
              setCurrentCorporateAccount(item);
              setEditModal(true);
            }}
          >
            <Pencil color={'#999999'} />
            <p>{t('corporateAccount.actions.edit')}</p>
          </div>
          <div
            className='corporate__dropdown-elem'
            onClick={() => {
              setCurrentCorporateAccount(item);
              setTurnStatus(true);
            }}
          >
            <ToggleOffIcon color={'#999999'} />
            <p>
              {item?.custom_inspections_enabled 
                ? t('corporateAccount.actions.turnOffCustomForm')
                : t('corporateAccount.actions.turnOnCustomForm')
              }
            </p>
          </div>
          <div
            className='corporate__dropdown-elem'
            onClick={() => {
              setCurrentCorporateAccount(item);
              if (type === 'active') {
                setDeactivateStatus(true);
              } else {
                setReactivateStatus(true);
              }
            }}
          >
            {type === 'active' ? (
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
                  stroke='#999999'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M4.92993 4.92993L19.0699 19.0699'
                  stroke='#999999'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            ) : (
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999'
                  stroke='#999999'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M22 4L12 14.01L9 11.01'
                  stroke='#999999'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            )}
            <p>{type === 'active' ? t('corporateAccount.actions.deactivate') : t('corporateAccount.actions.reactivate')}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CorporateAccountRow;
